import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/fun2win/Home.vue";
import DetailPage from "@/components/fun2win/DetailPage.vue";
import Profile from "@/components/fun2win/Profile.vue";
import Subcategory from "@/components/fun2win/Subcategory.vue";
import HotPicks from "@/components/fun2win/HotPicks.vue";
import Popular from "@/components/fun2win/Popular.vue";
import Login from "@/components/authentication/fun2win/Login.vue";
import Feedback from "../components/fun2win/Feedback.vue";
import PrivacyPolicy from "../components/fun2win/PrivacyPolicy.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  history: true,
  routes: [
    {
      path: "/home",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/home/:token"
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "/logout"
        }
      ]
    },
    {
      path: "/detail/:id",
      name: "DetailPage",
      component: DetailPage,
      children: [
        {
          path: "/detail/:id/:token"
        }
      ]
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      children: [
        {
          path: "/profile/:token"
        }
      ]
    },
    {
      path: "/hotpicks",
      name: "HotPicks",
      component: HotPicks,
      children: [
        {
          path: "/hotpicks/:token"
        }
      ]
    },
    {
      path: "/popular",
      name: "Popular",
      component: Popular,
      children: [
        {
          path: "/popular/:token"
        }
      ]
    },
    {
      path: "/subcategory/:subcategory",
      name: "Subcategory",
      component: Subcategory,
      children: [
        {
          path: "/subcategory/:subcategory/:token"
        }
      ]
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
      children: [
        {
          path: "/feedback/:token"
        }
      ]
    },
    {
      path: "/privacy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      children: [
        {
          path: "/privacy/:token"
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/fun2win.js